import { render, staticRenderFns } from "./IcoPencilSquare.vue?vue&type=template&id=3ce7aca2"
import script from "./IcoPencilSquare.vue?vue&type=script&lang=js"
export * from "./IcoPencilSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports